import { ActivityIndicator, Text, View } from "react-native";
import { useTranslation } from "react-i18next";

import type { UiTheme } from "../theme";
import { makeTierOneStyles } from "./panelStyles";
import { WidgetTitleRow } from "./InfoPill";

// Shared loading / error cards for the Tier-1 panels (lifted from mobile's
// TierOnePanels). `titleKey` is the short panel id (balance/pain/trends);
// the card renders `mobile.progress.<id>.title` in the WidgetTitleRow, which
// carries the collapse ▲ of an open Progress widget (PG-57).
export function LoadingCard({
  theme,
  titleKey,
}: {
  theme: UiTheme;
  titleKey: string;
}) {
  const styles = makeTierOneStyles(theme);
  return (
    <View style={styles.card}>
      <CardTitle theme={theme} titleKey={titleKey} />
      <ActivityIndicator color={theme.palette.brand500} />
    </View>
  );
}

export function ErrorCard({
  theme,
  titleKey,
}: {
  theme: UiTheme;
  titleKey: string;
}) {
  const { t } = useTranslation();
  const styles = makeTierOneStyles(theme);
  return (
    <View style={[styles.card, styles.cardError]}>
      <CardTitle theme={theme} titleKey={titleKey} />
      <Text style={styles.errorText}>
        {t("mobile.progress.loadFailed", { defaultValue: "Couldn’t load" })}
      </Text>
    </View>
  );
}

function CardTitle({ theme, titleKey }: { theme: UiTheme; titleKey: string }) {
  const { t } = useTranslation();
  return (
    <WidgetTitleRow
      theme={theme}
      title={t(`mobile.progress.${titleKey}.title`, { defaultValue: titleKey })}
    />
  );
}
